<template>
  <v-container fluid>
    <v-row class="mb-6">
      <v-col cols="12" align="center">
        <v-btn @click="clearAddress" text color="blue darken-3">
          <v-icon left>mdi-arrow-left-bold-circle</v-icon>Change address
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center">
        <h4
          class="text-h4 blue--text text--darken-4 text-center"
        >Not finding your address? We may still offer services at your location!</h4>
      </v-col>
    </v-row>
    <v-row class="mt-8" align="center" justify="center">
      <v-col v-for="(service, key) in serviceOffers" :key="key" align="center">
        <ServiceCard :service="service" />
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col>
        <h5 class="text-h5 text-center blue--text text--darken-4 mb-6">
          <a :href="`https://www.htc.net/service-contact/`" target="_parent">
            <strong>Click here</strong>
          </a> to provide your contact info. We'll reach out to get you signed up for service!
        </h5>
        <h5 class="text-h5 text-center blue--text text--darken-4">
          Or call
          <strong>618.939.6112</strong> to speak to our friendly local customer service team.
          We're available
          <strong>8:00am to 4:30pm Mon. - Fri</strong>.
        </h5>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceCard from "./ServiceCard.vue";

export default {
  components: { ServiceCard },
  name: "Services",

  props: ["city"],

  mounted() {
    this.fetchServiceOffers();
  },

  data: () => ({
    serviceOffers: []
  }),

  methods: {
    clearAddress() {
      this.$emit("clearAddress");
    },
    fetchServiceOffers() {
      this.$axios
        .get("/api/service-offers/unlisted-address", {
          params: {
            city: this.cityName
          }
        })
        .then(({ data }) => {
          this.serviceOffers = data;
        })
        .catch(() => {
          this.serviceOffers = [];
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    cityName() {
      return this.city && this.city.name ? this.city.name : null;
    }
  }
};
</script>
